import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { useTranslation } from 'react-i18next';
import {
  GetElementLinkDeatail,
  cleanUpElementLinkDeatail
} from '@store/HR/Payroll/ElementLinkSlice';

const useGetElementLink = (payrollId: string) => {
  const dispatch = useAppDispatch();
  const { ElementLinkDeatail, loading, error } = useAppSelector(state => state.ElementLink);

  const { i18n } = useTranslation();
  // console.log(typeof ElementLinkDeatail);

  useEffect(() => {
    if (payrollId && !ElementLinkDeatail) {
      dispatch(GetElementLinkDeatail(payrollId));
    }

    // return () => {
    //   dispatch(cleanUpElementLinkDeatail());
    // };
  }, [payrollId, dispatch]);

  const elementLink = ElementLinkDeatail?.elementLink;

  // console.log(elementLink);

  const elementCodes = elementLink
    ?.filter((f: any) => f.code !== null)
    ?.map((item: any) => ({
      id: item.elementTypeId,
      name: i18n.language === 'en' ? item.name : item.name2,
      value: `$${item.code}$`,
      description: ''
      // description: i18n.language === 'en' ? item.name : item.name2
    }));

  const elementType =
    ElementLinkDeatail &&
    ElementLinkDeatail?.elemntType?.map((item: any) => ({
      value: item.id,
      label: i18n.language === 'ar' ? item.name2 : item.name,
      isRecurring: item.isRecurring,
      uom: item.uom,
     }));
    // console.log(ElementLinkDeatail?.elemntType);
    



  return { ElementLinkDeatail, elementType, elementLink, elementCodes, loading, error };
};

export default useGetElementLink;
